import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState({ isAuthenticated: false, UserName: "", FullName: "" });
    const [isLoading, setIsLoading] = useState(true);
    const [customerList, setCustomerList] = useState([]);

    useEffect(() => {
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        const storedCustomers = JSON.parse(localStorage.getItem("customerList") || "[]");

        if (authUser) {
            setUser({
                isAuthenticated: !!authUser.isAuthenticated,
                UserName: authUser.UserName || authUser.USERNAME || "ADMIN",
                FullName: authUser.FullName || authUser.FULLNAME || authUser.UserName || "",
                SelectedCustomer_ID: authUser.SelectedCustomer_ID,
                SelectedCustomer_Name: authUser.SelectedCustomer_Name,
                Token: authUser.Token
            });
            setCustomerList(storedCustomers);
        }
        setIsLoading(false);
    }, []);


    useEffect(() => {
        if (customerList.length > 0 && user.isAuthenticated && !user.SelectedCustomer_ID) {
            const firstCustomer = customerList[1];
            const updatedUser = {
                ...user,
                SelectedCustomer_ID: firstCustomer.Customer_ID,
                SelectedCustomer_Name: firstCustomer.FirstName
            };
            setUser(updatedUser);
            const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
            localStorage.setItem(
                "authUser",
                JSON.stringify({
                    ...authUser,
                    ...updatedUser
                })
            );
        }
    }, [customerList, user.isAuthenticated]);

    const switchCustomer = (customer) => {
        const updatedUser = {
            ...user,
            SelectedCustomer_ID: customer.Customer_ID,
            SelectedCustomer_Name: customer.FirstName
        };

        setUser(updatedUser);

        const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
        localStorage.setItem("authUser", JSON.stringify({
            ...authUser,
            ...updatedUser
        }));
    };

    return (
        <AuthContext.Provider value={{ user, setUser, customerList, setCustomerList, switchCustomer, isLoading }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);